import { Text } from '@akin-home/text/native';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { TouchableOpacity } from 'react-native';
import styled from 'styled-components/native';
import Spacer from '../../components/Spacer';

interface Props {
  title?: string;

  icon?: IconProp;

  onPressOpen?(): void;

  onDismiss?(): void;
}

export const ChatItemHeader = (props: Props) => {
  const { title, icon, onPressOpen, onDismiss } = props;

  return (
    <Container>
      <TitleContainer>
        {icon ? (
          <IconCircle>
            <FontAwesomeIcon icon={icon} color="white" size={18} />
          </IconCircle>
        ) : null}

        {title ? (
          <Title variant="caption" weight="semibold">
            {title.toUpperCase()}
          </Title>
        ) : null}
      </TitleContainer>

      <RightButtonsContainer>
        {onPressOpen ? (
          <TouchableOpacity onPress={onPressOpen}>
            <FontAwesomeIcon icon="external-link-alt" color="white" size={18} />
          </TouchableOpacity>
        ) : null}

        {onDismiss ? (
          <>
            <Spacer width="16px" />

            <TouchableOpacity onPress={onDismiss}>
              <FontAwesomeIcon icon="times" color="white" size={18} />
            </TouchableOpacity>
          </>
        ) : null}
      </RightButtonsContainer>
    </Container>
  );
};

const Container = styled.View`
  height: 56px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  border-bottom-width: 1px;
  border-bottom-color: rgba(255, 255, 255, 0.2);

  padding: 13px 15px;
  max-width: 100%;
  width: 100%;
  overflow: hidden;
`;

const TitleContainer = styled.View`
  flex-direction: row;
  align-items: center;
`;

const RightButtonsContainer = styled.View`
  flex-direction: row;
  justify-content: flex-end;
`;

const IconCircle = styled.View`
  margin-right: 12px;

  height: 34px;
  width: 34px;
  background-color: rgba(255, 255, 255, 0.15);

  border-radius: 20px;

  align-items: center;
  justify-content: center;
`;

const Title = styled(Text)`
  color: rgba(255, 255, 255, 0.6);
`;
